const eachActionServoObj = (MSB, LSB) => {
    return {
        isEnabled: false,
        value: (MSB << 8) | LSB,
    }
}
const bytesToActions = (actionGroupBytes) => {
    try {
        let index = 0
        let totalTime = 0

        // Validate header
        // if (
        //     actionGroupBytes[index++] !== 'G'.charCodeAt(0) ||
        //     actionGroupBytes[index++] !== 'R'.charCodeAt(0)
        // ) {
        //     throw new Error('Invalid byte sequence: Missing header (GR)')
        // }

        // Extract file name length and file name
        // let fileNameLength = actionGroupBytes[index++]
        // let fileName = String.fromCharCode(
        //     ...actionGroupBytes.slice(index, index + fileNameLength)
        // )
        // index += fileNameLength

        // Extract number of actions (MSB, LSB)
        let actionCount =
            (actionGroupBytes[index] << 8) | actionGroupBytes[index + 1]
        index += 2

        let actionsData = {
            commonActionState: {},
            allActions: [],
            projectName: '',
        }

        // Initialize commonActionState
        const connectedDevice = sessionStorage.getItem('connectedDevice') || ''
        const actionKeys = Array.from(
            { length: connectedDevice === 'Hexapod' ? 18 : 16 },
            (_, i) => (i + 1).toString()
        )

        if (connectedDevice === 'Humanoid') {
            actionKeys.push('H')
        }
        actionKeys.unshift('T')

        actionKeys.forEach((key) => {
            actionsData.commonActionState[key] = { isSelected: false }
        })
        actionsData.commonActionState['T'].isSelected = true // Assuming "T" is always selected

        // Loop through each action
        for (let i = 0; i < actionCount; i++) {
            let action = {
                id: `region-${Math.random().toString(36).substr(2, 10)}`, // Generating a random ID
                data: {},
                markerPositionTime: (Math.random() * 1).toFixed(3), // Dummy time
                actionName: `Action ${i + 1}`,
            }

            // Read servo values for each key
            actionKeys.forEach((key) => {
                if (key !== 'H') {
                    let MSB = actionGroupBytes[index++]
                    let LSB = actionGroupBytes[index++]
                    let value = (MSB << 8) | LSB
                    action.data[key] = {
                        isEnabled: false,
                        value,
                    }
                    if (key === 'T') {
                        totalTime = totalTime + (JSON.parse(value) || value)
                        action.markerPositionTime = totalTime / 1000
                    }
                } else {
                    action.data[key] = {
                        isEnabled: false,
                        value: actionGroupBytes[index++],
                    }
                }
            })

            actionsData.allActions.push(action)
        }

        // extract the action details array
        let actionDetails = null
        if (
            actionGroupBytes[index++] == 'E'.charCodeAt(0) ||
            actionGroupBytes[index++] == 'R'.charCodeAt(0)
        ) {
            actionDetails = String.fromCharCode(
                ...actionGroupBytes.slice(index + 1)
            )
            actionDetails = JSON.parse(actionDetails)
        }

        //add the action name in actionsData object
        actionsData.allActions.map((action, ind) => {
            if (actionDetails?.actionDetails?.[ind]?.actionName) {
                action.actionName =
                    actionDetails?.actionDetails?.[ind]?.actionName
            }
        })
        actionsData.projectName = actionDetails?.projectName || ''
        return { newActionsData: actionsData, actionDetails }
    } catch (error) {
        console.error('Error parsing actionGroupBytes:', error)
        return {}
    }
}

//calculate the waiting time
const calculateWaitTime = (fileSize) => {
    //we assume the write speed is 3mbps
    let writeSpeed = (3 * 10) ^ 6
    let waitTime = ((fileSize * 8) / writeSpeed) * 1000
    return waitTime + 5000
}

//convert the all files in a directory response to a array where present only the file name
const convertFileArrFormat = (listResponse) => {
    const files = listResponse?.files || []

    const result = {
        fileArray: [],
        mp3FileArray: [],
    }

    files.forEach((file) => {
        if (!file?.is_file || !file?.filename) return

        if (file.filetype === 'bin') {
            result.fileArray.push(file.filename.replace(/\.bin$/i, ''))
        } else if (file.filetype === 'mp3') {
            result.mp3FileArray.push(file.filename.replace(/\.mp3$/i, ''))
        }
    })

    return result
}

// get the list of action file present in zing , and check same file present or not
//also remove the audio file if saving time user did not put any mp3 file
const checkFileExist = async ({
    socket,
    filePath,
    filename,
    isAudioFilePresent,
}) => {
    try {
        //get the Lists all files in a directory on the mounted USB device.
        let listResponse = await getListFile({
            socket,
            filePath: filePath,
        })

        let nameArray = { fileArray: [], mp3FileArray: [] }

        if (listResponse.success) {
            nameArray = convertFileArrFormat(listResponse)
        } else {
            throw new Error('Action does not save')
        }

        if (nameArray.fileArray.includes(filename)) {
            const result = window.confirm(
                'A file with the same name already exists. Are you sure you want to replace it?'
            )
            if (result === false) {
                return false
            }
        }

        if (!isAudioFilePresent && nameArray.mp3FileArray.includes(filename)) {
            let removeResponse = await removeFile({
                socket,
                filePath: filePath + '/' + filename + '.mp3',
            })
        }
        return true
    } catch (e) {
        console.log('ERROR', e)
        throw new Error('Action does not save')
    }
}

//get the device mount point
const getMountPoint = ({ socket }) => {
    return new Promise((resolve, reject) => {
        socket.emit('list-mount', (response) => {
            if (response.success) {
                resolve(response.output)
            } else {
                reject(new Error(response.error))
            }
        })

        // Optional: add a timeout to reject the promise if no response is received
        setTimeout(() => {
            reject(new Error('Timeout while waiting for list-mount response'))
        }, 10000) // 10 seconds timeout
    })
}

//Lists all files in a directory on the mounted USB device
const getListFile = ({ socket, filePath }) => {
    return new Promise((resolve, reject) => {
        console.log({ socket, filePath })
        socket.emit('list-files', { file_path: filePath }, (response) => {
            resolve(response)
        })

        // Optional: add a timeout to reject the promise if no response is received
        setTimeout(() => {
            reject(new Error('Timeout while waiting for list-files response'))
        }, 60000) // 60 seconds timeout
    })
}

//Writes a file to the USB device
const writeFile = ({
    socket,
    fileName,
    fileFormat,
    filePath,
    fileData,
    writeTime,
}) => {
    console.log({ fileName, fileFormat, filePath, writeTime })
    return new Promise((resolve, reject) => {
        socket.emit(
            'add-file',
            {
                name: fileName,
                format: fileFormat,
                path: filePath,
                data: fileData,
            },
            (response) => {
                resolve(response)
            }
        )

        // Optional: add a timeout to reject the promise if no response is received
        setTimeout(() => {
            reject(new Error('Timeout while waiting for add-file response'))
        }, writeTime)
    })
}

//Removes a file from the USB device
const removeFile = ({ socket, filePath }) => {
    return new Promise((resolve, reject) => {
        socket.emit('remove-file', { file_path: filePath }, (response) => {
            resolve(response)
        })

        // Optional: add a timeout to reject the promise if no response is received
        setTimeout(() => {
            reject(new Error('Timeout while waiting for remove-file response'))
        }, 60000) // 60 seconds timeout
    })
}

//Reads a file from the USB device and returns its contents as base64 encoded data.
const readsFile = ({ socket, filePath }) => {
    return new Promise((resolve, reject) => {
        socket.emit('read-file', { file_path: filePath }, (response) => {
            resolve(response)
        })

        // Optional: add a timeout to reject the promise if no response is received
        setTimeout(() => {
            reject(new Error('Timeout while waiting for read-file response'))
        }, 120000) // 60 seconds timeout
    })
}

export {
    bytesToActions,
    calculateWaitTime,
    convertFileArrFormat,
    getMountPoint,
    getListFile,
    writeFile,
    removeFile,
    readsFile,
    checkFileExist,
}
